import { QueryHookOptions } from '@apollo/client';

import {
  UsersListCountQuery,
  UsersListCountQueryVariables,
  useUsersListCountQuery,
} from 'shared/graphql';

type Options = QueryHookOptions<UsersListCountQuery, UsersListCountQueryVariables>;

/**
 * Custom hook to fetch the total count of users, optionally filtered by query options.
 *
 * @param {Options} [options] - Optional Apollo query options for filtering, skipping, or customizing the query.
 */
export function useUsersListCount(options?: Options) {
  const { data, loading } = useUsersListCountQuery(options);

  const count = data?.users?.count ?? 0;

  return {
    count,
    loading,
  };
}
